import { Component } from "react";
import { connect } from "react-redux";
import AbsenceTable from "./AbsenceTable";
import AbsenceStatusIcon from "./AbsenceStatusIcon";
import { setEditionState, selectAbsence, getDaysNumber } from "../../redux/absences/absencesActions";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import moment from "moment";
import "./AbsenceTable.css";
import { ALL_SELECT_OPTION } from "../../constants";

class MyAbsencesTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            getFilteredAbsences: this.getFilteredAbsences,
            filteredAbsences: this.getFilteredAbsences(props),
            columns: [
                {
                    Header: "Mes absences",
                    className: "text-center",
                    columns: [
                        {
                            Header: "Statut",
                            id: "state",
                            filterable: false,
                            width: 100,
                            className: "smallColumn",
                            accessor: (a) => a.state, 
                            Cell: ({value}) => {
                                if (!value) return null;

                                return (
                                    <div className="displayFlex">
                                        <AbsenceStatusIcon status={value} />
                                    </div>
                                );
                            },
                        },
                        {
                            Header: "Début\nFin",
                            id: "date_from",
                            className: "linebreak largeColumn",
                            accessor: (a) => moment(a.date_ids[0].date).format("DD/MM/YYYY") + "\n" + 
                                             moment(a.date_ids[a.date_ids.length - 1].date).format("DD/MM/YYYY"),
                        },
                        {
                            Header: "Nb Jours",
                            id: "nbDays",
                            className: "smallColumn",
                            accessor: (a) => getDaysNumber(a.date_ids),
                        },
                        {
                            Header: "Code",
                            accessor: "code",
                            className: "largeColumn",
                        },
                    ],
                },
            ],
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let modifiedState = prevState;

        modifiedState.filteredAbsences = prevState.getFilteredAbsences(nextProps);
        return modifiedState;
    }

    getFilteredAbsences(props) {
        let filteredAbsences = props.absences.absences;

        if (props.absences.absencesStatusFilter !== ALL_SELECT_OPTION)
            filteredAbsences = filteredAbsences.filter((a) => a.state === props.absences.absencesStatusFilter);

        return filteredAbsences;
    }

    getTableTrProps(row) {
        if (row) {
            return {
                onClick: function () {
                    this.props.setEditionState(false, true, false);
                    this.props.selectAbsence(row.original);
                    this.props.history.push("/absences/editAbsence");
                }.bind(this),
                style: {
                    cursor: 'pointer'
                },
            }
        } else {
            return {};
        }
    }

    render() {
        return (
            <div>
                <AbsenceTable
                    data={this.state.filteredAbsences}
                    columns={this.state.columns}
                    getTrProps={this.getTableTrProps.bind(this)}
                    filterable={false}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        absences: state.absences,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setEditionState: (creationMode, updateMode, validationMode) =>
            dispatch(setEditionState(creationMode, updateMode, validationMode)),
        selectAbsence: (absence) => dispatch(selectAbsence(absence)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(MyAbsencesTable);
